import React, { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Typography,
  styled,
  TextField,
  Paper,
  Grid,
  Box,
  Tab,
  Tabs,
  Fab,
  MenuItem,
  Snackbar,
  IconButton,
  InputAdornment,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import ClearIcon from '@mui/icons-material/Clear';
import { Context } from "context/Wrapper";
import Swal from 'sweetalert2';
import { serverTimestamp } from "firebase/firestore";
import { SaveCloseDialog } from "../components/SaveCloseDialog";
import { Add, Save, Close } from "@mui/icons-material";
import { useForm, Controller, useFormState } from "react-hook-form";
import PersonStatus from "./PersonStatus";
import Notes from "components/Notes";

import { doc, getDoc, setDoc, where, getDocs, collection, query, writeBatch } from "firebase/firestore";
import { db } from "config/config";
import InfiniteScrollSelect from "components/shared/InfiniteScrollSelect";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Item = styled(Paper)(({ theme }) => {
  return {
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.primary.main,
    background: theme.palette.secondary.main,
  };
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

export { TabPanel };

export const ContactDetail = (props) => {
  const { contactId } = useParams();
  const context = useContext(Context);

  const { groupId } = context?.state?.userProfile || {};

  const navigate = useNavigate();

  const [contactDetail, setContactDetail] = useState();

  useEffect(() => {
    async function getContacts() {
      const contactRef = doc(db, "contacts", contactId);
      const initialContactDetail = await getDoc(contactRef);
      setContactDetail(initialContactDetail.data());
    }

    getContacts();
  }, [contactId]);

  const { handleSubmit, control, reset } = useForm();

  const [tab, setTab] = React.useState(0);

  const [open, setOpen] = React.useState(false);

  const [dialogOpen, setDialogOpen] = React.useState(false);

  const [failureOpen, setOpenFailure] = React.useState(false);
  const [duplicateOpen, setduplicateOpen] = React.useState(false);
  const [SubmitLoader, setSubmitLoader] = React.useState(false);


  const openSuccess = () => {
    setOpen(true);
  };

  const openFailure = () => {
    setOpenFailure(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleFailureClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenFailure(false);
  };

  const handleduplicateOpen = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setduplicateOpen(false);
  };

  const handleChangeTab = (event, newValue) => {
    setTab(newValue);
  };

  const handleChange = (e) => {
    let currentContactDetail = contactDetail;
    currentContactDetail[e.target.name] = e.target.value;
    setIsDirty(true);
    setContactDetail({ ...currentContactDetail });
  };

  const handleChangeNotes = (notes) => {
    let currentContactDetail = contactDetail;
    setContactDetail({ ...currentContactDetail, notes: notes });
  };

  //   const onSubmit = async() => {

  //     setSubmitLoader(true)
  //     // Normalize the full name for comparison
  //     const normalizedFullName = contactDetail.fullName.trim();
  //     const thisContact = doc(db, "contacts", contactId);

  //     // Check if any other contact has the same full name (case-insensitive)
  //     await db.collection("contacts")
  //       .get()
  //       .then((querySnapshot) => {
  //         // Check if there's any other document with the same name but different ID
  //         const isDuplicate = querySnapshot.docs.some(doc => {
  //           const docData = doc.data();
  //           const docFullName = docData.fullName ? docData.fullName.trim().toLowerCase() : '';
  //           return doc.id !== contactId && docFullName === normalizedFullName.toLowerCase();
  //         });

  //         if (!isDuplicate) {
  //           // If no duplicates, proceed to update the document
  //           setDoc(thisContact, {
  //             ...contactDetail,
  //             fullName: normalizedFullName, // Store original case-sensitive version
  //           }, { merge: true })
  //             .then(() => {
  //               setIsDirty(false);
  //               openSuccess();
  //               setSubmitLoader(false)
  //             })
  //             .catch((error) => {
  //               console.error("Error updating document: ", error);
  //               openFailure();
  //               setSubmitLoader(false)
  //             });
  //         } else {
  //           // If a matching document is found, display an error
  //           setduplicateOpen(true);
  //           setSubmitLoader(false);
  //         }
  //       })
  //       .catch((error) => {
  //         console.error("Error checking for unique customerReference: ", error);
  //         setSubmitLoader(false)
  //       });
  // };

  const onSubmit = async () => {
    setSubmitLoader(true);

    // 1) Normalize your contact fields
    const normalizedFullName = contactDetail.fullName.trim();
    const normalizedFullNameLc = normalizedFullName.toLowerCase();
    const normalizedBusinessName = (contactDetail.businessName || '').trim();
    const normalizedBusinessNameLc = normalizedBusinessName.toLowerCase();

    // 2) Display name for filingRep: prefer businessName, otherwise fullName
    const filingRepDisplay = normalizedBusinessName || normalizedFullName;
    const filingRepDisplayLc = filingRepDisplay.toLowerCase();

    // Firestore ref to this contact
    const thisContact = doc(db, "contacts", contactId);

    try {
      // Get current timestamp in epoch format
      const currentTimestamp = Date.now();

      await setDoc(thisContact, {
        ...contactDetail,
        fullName: normalizedFullName,
        fullName_lc: normalizedFullNameLc,
        dateCreated: typeof contactDetail.dateCreated === 'number' ?
          contactDetail.dateCreated :
          contactDetail.dateCreated?.toMillis() || currentTimestamp,
        dateUpdated: currentTimestamp, // Changed to epoch
        businessName: normalizedBusinessName,
        businessName_lc: normalizedBusinessNameLc,
        email_lc: (contactDetail.email || '').trim().toLowerCase(),
      }, { merge: true });

      const projectsBatch = writeBatch(db);

      const clientQ = query(collection(db, "projects"), where("client", "==", contactId));
      const clientSnap = await getDocs(clientQ);
      clientSnap.forEach(docSnap =>
        projectsBatch.update(docSnap.ref, { client_lc: normalizedBusinessNameLc })
      );

      const tenantQ = query(collection(db, "projects"), where("tenant", "==", contactId));
      const tenantSnap = await getDocs(tenantQ);
      tenantSnap.forEach(docSnap =>
        projectsBatch.update(docSnap.ref, { tenant_lc: normalizedBusinessNameLc })
      );

      const filingRepQ = query(collection(db, "projects"), where("filingRep", "==", contactId));
      const filingRepSnap = await getDocs(filingRepQ);
      filingRepSnap.forEach(docSnap =>
        projectsBatch.update(docSnap.ref, {
          filingRepName: filingRepDisplay,
          filingRep_lc: filingRepDisplayLc,
        })
      );

      const applicantQ = query(collection(db, "projects"), where("applicant", "==", contactId));
      const applicantSnap = await getDocs(applicantQ);
      applicantSnap.forEach(docSnap =>
        projectsBatch.update(docSnap.ref, {
          applicantName: normalizedFullName,
          applicant_lc: normalizedFullNameLc,
        })
      );

      if (
        !clientSnap.empty ||
        !tenantSnap.empty ||
        !filingRepSnap.empty ||
        !applicantSnap.empty
      ) {
        await projectsBatch.commit();
      }

      const buildingsQ = query(collection(db, "buildings"), where("owner", "==", contactId));
      const buildingsSnap = await getDocs(buildingsQ);
      if (!buildingsSnap.empty) {
        const b = writeBatch(db);
        buildingsSnap.forEach(d => {
          b.update(d.ref, {
            ownerString: normalizedBusinessName,
            ownerString_lc: normalizedBusinessNameLc,
          });
        });
        await b.commit();
      }

      const invoicesQ = query(collection(db, "invoices"), where("invoiceFor", "==", contactId));
      const invoicesSnap = await getDocs(invoicesQ);
      if (!invoicesSnap.empty) {
        const invBatch = writeBatch(db);
        invoicesSnap.forEach(docSnap => {
          invBatch.update(docSnap.ref, {
            customerName: normalizedFullName,
            invoiceFor_lc: normalizedFullNameLc
          });
        });
        await invBatch.commit();
      }

      setIsDirty(false);
      openSuccess();
      return true;

    } catch (error) {
      console.error("Error updating contact or related docs:", error);
      openFailure();
      return false;
    } finally {
      setSubmitLoader(false);
    }
  };

  const saveAndClose = async () => {
    const isSuccess = await onSubmit();
    if (isSuccess) {
      navigate("/Contacts", { state: { feedback: { message: 'Contact saved successfully!', severity: 'success' } } });
    } else {
      setDialogOpen(false);
    }
  };


  const discardAndClose = () => {
    navigate("/Contacts");
  };

  const [isDirty, setIsDirty] = React.useState(false);

  const handleCloseContact = () => {
    if (isDirty && !props.isInactive) {
      setDialogOpen(true);
      return;
    }
    navigate("/contacts");
  };

  const hasRequiredFields = () => {
    return !!contactDetail.fullName;
  };


  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setContactDetail({
      ...contactDetail,
      [name]: checked ? true : false,
    });
  };



  const handleChangeDetails = async (e) => {
    const { name, value } = e.target;
    if (isDirty && !props.isInactive) {
      const result = await Swal.fire({
        title: 'You have unsaved changes!',
        text: "Do you want to save your changes or discard them?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Save',
        cancelButtonText: 'Discard',
      });

      if (result.isConfirmed) {
        const isSuccess = await onSubmit();
        if (isSuccess) {
          navigate(`/contacts/details/${value}`);
          window.location.reload();
        }
      } else {
        navigate(`/contacts/details/${value}`);
        window.location.reload();
      }
    } else {
      navigate(`/contacts/details/${value}`);
      window.location.reload();
    }
  };



  // const handleChangeDetails = (e) => {
  //   const { name, value } = e.target;
  //   if (name === "fullName") {
  //     navigate(`/contacts/details/${value}`); 
  //      window.location.reload(); 
  //   }
  // };

  if (!contactDetail) return null;


  return (
    <>

      <Grid container spacing={2} sx={{ marginBottom: "-55px", justifyContent: "flex-end" }}>

        <Grid item xs={12} md={6} lg={4}>
          <InfiniteScrollSelect
            disableClear={true}
            collectionName="contacts"
            label="fullName"
            onChange={handleChangeDetails}
            value={contactDetail?.fullName}
            name="fullName"
            inputLabel="Switch to another Contact"
          />
        </Grid>
      </Grid>


      <Typography sx={{ textTransform: "uppercase" }} align="left" variant="h4">
        {contactDetail.fullName}
      </Typography>
      <Box sx={{ borderBottom: 1, borderColor: "divider", paddingLeft: 0 }}>
        <Tabs
          value={tab}
          onChange={handleChangeTab}
          aria-label="basic tabs example"
        >
          <Tab label="Details" />
          <Tab label="DOB status" />
          <Tab label="Notes" />
          {/*  <Tab label="Applications" /> */}
        </Tabs>
      </Box>
      <TabPanel value={tab} index={0}>
        <form name="contactForm" id="contactForm">
          <Grid container spacing={2}>
            {/* 
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                label={"Salutation"}
                name="salutation"
                select
                onChange={handleChange}
                value={contactDetail.borough}
                fullWidth
              >
                <MenuItem value={"Mr"}>Mr</MenuItem>
                <MenuItem value={"Mrs"}>Mrs</MenuItem>
                <MenuItem value={"Ms"}>Ms</MenuItem>
                <MenuItem value={"Miss"}>Miss</MenuItem>
                <MenuItem value={"Mx"}>Mx</MenuItem>
                <MenuItem value={"Dr"}>Dr.</MenuItem>
                <MenuItem value={"Rev"}>Rev</MenuItem>
                <MenuItem value={"Rabbi"}>Rabbi</MenuItem>
              </TextField>
            </Grid> */}



            {/* 

<Paper
  elevation={3}
  sx={{
    padding: "1.5rem",
    borderRadius: "8px",
    backgroundColor: "#f9f9f9",
    // maxWidth: "600px",
    width: "100%", // Take full width
    margin: "15px auto",
  }}
>
  <Typography
    variant="h6"
    sx={{
      marginBottom: "1rem",
      fontWeight: "bold",
      textAlign: "center",
      color: "#333",
    }}
  >
   Contact Types
  </Typography>
  <Grid container spacing={2}>
    {[
      "employee",
      "client",
      "owner",
      "tenant",
      "filingRep",
      "architect",
      "engineer",
      "contractor",
    ].map((type) => (
      <Grid item xs={6} sm={4} key={type}>
        <FormControlLabel
          control={
            <Checkbox
              checked={!!contactDetail[type]}
              onChange={handleCheckboxChange}
              name={type}
              size="small" // Compact checkbox
            />
          }
          label={type.charAt(0).toUpperCase() + type.slice(1)} // Capitalized label
          sx={{
            fontSize: "0.85rem",
            "& .MuiTypography-root": {
              fontSize: "0.95rem",
              color: "#555", // Neutral color for labels
            },
          }}
        />
      </Grid>
    ))}
  </Grid>
</Paper>






      <Grid item xs={12} md={6} lg={4}>
        <TextField
       label={"Salutation"}
      name="salutation"
       variant="outlined" 
      select
      onChange={handleChange}
      value={contactDetail.salutation || ""}
      fullWidth
        InputProps={{
         endAdornment: contactDetail.salutation ? ( 
        <InputAdornment position="end">
          <IconButton
            onClick={() => handleChange({ target: { name: 'salutation', value: '' } })}
            style={{ marginRight: '10px' }} 
          >
            <ClearIcon />
          </IconButton>
        </InputAdornment>
      ) : null
    }}
     >
    <MenuItem value={"Mr"}>Mr</MenuItem>
    <MenuItem value={"Mrs"}>Mrs</MenuItem>
    <MenuItem value={"Ms"}>Ms</MenuItem>
    <MenuItem value={"Miss"}>Miss</MenuItem>
    <MenuItem value={"Mx"}>Mx</MenuItem>
    <MenuItem value={"Dr"}>Dr.</MenuItem>
    <MenuItem value={"Rev"}>Rev</MenuItem>
    <MenuItem value={"Rabbi"}>Rabbi</MenuItem>
  </TextField>
</Grid>



            <Grid item xs={12} md={6} lg={4}>
              <TextField
                label="Full Name"
                name="fullName"
                variant="outlined"
                value={contactDetail.fullName}
                onChange={handleChange}
                fullWidth
                required
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                label="First name"
                name="firstName"
                variant="outlined"
                value={contactDetail.firstName}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                label="MI"
                name="MI"
                variant="outlined"
                value={contactDetail.MI}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                label="Last name"
                name="lastName"
                variant="outlined"
                value={contactDetail.lastName}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                label="DOB Login"
                name="dobLogin"
                variant="outlined"
                value={contactDetail.dobLogin}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

        

            <Grid item xs={12} md={6} lg={4}>
       <TextField
    label="Designation"
    name="designation"
    variant="outlined"
    select
    value={contactDetail.designation || ""}
    onChange={handleChange}
    fullWidth
    InputProps={{
      endAdornment: contactDetail.designation ? (
        <InputAdornment position="end">
          <IconButton
            onClick={() => handleChange({ target: { name: 'designation', value: '' } })}
            style={{ marginRight: '10px' }} 
          >
            <ClearIcon />
          </IconButton>
        </InputAdornment>
      ) : null
    }}
  >
    <MenuItem value="Owner">Owner</MenuItem>
    <MenuItem value="Registered Architect">Registered Architect</MenuItem>
    <MenuItem value="Professional Engineer">Professional Engineer</MenuItem>
    <MenuItem value="Special Inspection Agency">Special Inspection Agency</MenuItem>
  </TextField>
</Grid> */}



            {/* <Grid container spacing={2} sx={{marginBottom:"30px",marginTop: "10px" }}>
  
   <Grid item xs={12} md={6} lg={4}>
              <InfiniteScrollSelect
                disableClear={true}
                collectionName="contacts"
                 label="fullName"
                onChange={handleChangeDetails}
                value={contactDetail?.fullName}
                name="fullName"
                inputLabel="Select Contact"
              />
            </Grid>
</Grid> */}



            <Grid container spacing={3} sx={{ marginTop: "10px" }}>
              {/* Left Side: Form Fields (2/3 of width) */}
              <Grid item xs={12} md={8}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label={"Salutation"}
                      name="salutation"
                      variant="outlined"
                      select
                      onChange={handleChange}
                      value={contactDetail.salutation || ""}
                      fullWidth
                      InputProps={{
                        endAdornment: contactDetail.salutation ? (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() =>
                                handleChange({ target: { name: "salutation", value: "" } })
                              }
                              style={{ marginRight: "10px" }}
                            >
                              <ClearIcon />
                            </IconButton>
                          </InputAdornment>
                        ) : null,
                      }}
                    >
                      <MenuItem value={"Mr"}>Mr</MenuItem>
                      <MenuItem value={"Mrs"}>Mrs</MenuItem>
                      <MenuItem value={"Ms"}>Ms</MenuItem>
                      <MenuItem value={"Miss"}>Miss</MenuItem>
                      <MenuItem value={"Mx"}>Mx</MenuItem>
                      <MenuItem value={"Dr"}>Dr.</MenuItem>
                      <MenuItem value={"Rev"}>Rev</MenuItem>
                      <MenuItem value={"Rabbi"}>Rabbi</MenuItem>
                    </TextField>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Full Name"
                      name="fullName"
                      variant="outlined"
                      value={contactDetail.fullName}
                      onChange={handleChange}
                      fullWidth
                      required
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="First Name"
                      name="firstName"
                      variant="outlined"
                      value={contactDetail.firstName}
                      onChange={handleChange}
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="MI"
                      name="MI"
                      variant="outlined"
                      value={contactDetail.MI}
                      onChange={handleChange}
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Last Name"
                      name="lastName"
                      variant="outlined"
                      value={contactDetail.lastName}
                      onChange={handleChange}
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="DOB Login"
                      name="dobLogin"
                      variant="outlined"
                      value={contactDetail.dobLogin}
                      onChange={handleChange}
                      fullWidth
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      label="Designation"
                      name="designation"
                      variant="outlined"
                      select
                      value={contactDetail.designation || ""}
                      onChange={handleChange}
                      fullWidth
                      InputProps={{
                        endAdornment: contactDetail.designation ? (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() =>
                                handleChange({
                                  target: { name: "designation", value: "" },
                                })
                              }
                              style={{ marginRight: "10px" }}
                            >
                              <ClearIcon />
                            </IconButton>
                          </InputAdornment>
                        ) : null,
                      }}
                    >
                      <MenuItem value="Owner">Owner</MenuItem>
                      <MenuItem value="Registered Architect">Registered Architect</MenuItem>
                      <MenuItem value="Professional Engineer">
                        Professional Engineer
                      </MenuItem>
                      <MenuItem value="Special Inspection Agency">
                        Special Inspection Agency
                      </MenuItem>
                    </TextField>
                  </Grid>
                </Grid>
              </Grid>

              {/* Right Side: Contact Types Section (1/3 of width) */}
              <Grid item xs={12} md={4}>
                <Paper
                  elevation={3}
                  sx={{
                    padding: "1.5rem",
                    borderRadius: "8px",
                    backgroundColor: "#f9f9f9",
                    width: "100%",
                    // margin: "5px auto",
                    margin: {
                      md: "15px auto",
                      lg: 0,
                    },
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      marginBottom: "1rem",
                      fontWeight: "bold",
                      textAlign: "center",
                      color: "#333",
                    }}
                  >
                    Contact Types
                  </Typography>
                  <Grid container spacing={2}>
                    {[
                      "employee",
                      "client",
                      "owner",
                      "tenant",
                      "filingRep",
                      "architect",
                      "engineer",
                      "contractor",
                    ].map((type) => (
                      <Grid item xs={6} sm={6} key={type}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={!!contactDetail[type]}
                              onChange={handleCheckboxChange}
                              name={type}
                              size="small"
                            />
                          }
                          label={type.charAt(0).toUpperCase() + type.slice(1)}
                          sx={{
                            fontSize: "0.85rem",
                            "& .MuiTypography-root": {
                              fontSize: "0.95rem",
                              color: "#555",
                            },
                          }}
                        />
                      </Grid>
                    ))}
                  </Grid>
                </Paper>
              </Grid>
            </Grid>


          </Grid>
          <Grid container sx={{ marginTop: "2rem" }} spacing={2}>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                label="Business name"
                name="businessName"
                variant="outlined"
                value={contactDetail.businessName}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                label="Address 1"
                name="address1"
                variant="outlined"
                value={contactDetail.address1}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                label="Address 2"
                name="address2"
                variant="outlined"
                value={contactDetail.address2}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                label="City"
                name="city"
                variant="outlined"
                value={contactDetail.city}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                label="State"
                name="state"
                variant="outlined"
                value={contactDetail.state}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                label="ZIP"
                name="ZIP"
                variant="outlined"
                value={contactDetail.ZIP}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
          </Grid>
          <Grid container sx={{ marginTop: "2rem" }} spacing={2}>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                label="Phone"
                name="phone"
                variant="outlined"
                value={contactDetail.phone}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                label="Cell"
                name="mobile"
                variant="outlined"
                value={contactDetail.mobile}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                label="Fax"
                name="fax"
                variant="outlined"
                value={contactDetail.fax}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                label="Email"
                name="email"
                variant="outlined"
                value={contactDetail.email}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                label="Website"
                name="website"
                variant="outlined"
                value={contactDetail.website}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
          </Grid>
          <Grid container sx={{ marginTop: "2rem" }} spacing={2}>

            <Grid item xs={12} md={6} lg={4}>
              <TextField
                label="License type"
                name="licenseType"
                variant="outlined"
                select
                value={contactDetail.licenseType || ""}
                onChange={handleChange}
                fullWidth
                InputProps={{
                  endAdornment: contactDetail.licenseType ? (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => handleChange({ target: { name: 'licenseType', value: '' } })}
                        style={{ marginRight: '10px' }}
                      >
                        <ClearIcon />
                      </IconButton>
                    </InputAdornment>
                  ) : null
                }}
              >
                <MenuItem value={"RA"}>RA</MenuItem>
                <MenuItem value={"PE"}>PE</MenuItem>
                <MenuItem value={"Filing rep"}>Filing rep</MenuItem>
                <MenuItem value={"Other"}>Other</MenuItem>
              </TextField>
            </Grid>



            <Grid item xs={12} md={6} lg={4}>
              <TextField
                label="License number"
                name="licenseNumber"
                variant="outlined"
                value={contactDetail.licenseNumber}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                label="Filing rep registration number"
                name="frepRegistrationNumber"
                variant="outlined"
                value={contactDetail.frepRegistrationNumber}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                label="Tax id"
                name="taxId"
                variant="outlined"
                value={contactDetail.taxId}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} md={6} lg={4}>
              <TextField
                label="Tracking Number"
                name="trackingNumber"
                variant="outlined"
                value={contactDetail.trackingNumber || ""}
                onChange={handleChange}
                fullWidth
              />
            </Grid>

            <Grid item xs={12} md={6} lg={4}>
              <TextField
                label="HIC number"
                name="HICNumber"
                variant="outlined"
                value={contactDetail.HICNumber}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                label="Insurance company"
                name="insuranceCompany"
                variant="outlined"
                value={contactDetail.insuranceCompany}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <TextField
                label="Policy number"
                name="policyNumber"
                variant="outlined"
                value={contactDetail.policyNumber}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
          </Grid>
        </form>
        <Box
          sx={{
            position: "fixed",
            bottom: "1rem",
            right: "1rem",
            "& > :not(style)": { m: 1 },
          }}
        >
          {!props.isInactive && (
            <Fab
              color="primary"
              aria-label="add"
              variant="extended"
              onClick={onSubmit}
              form="contactForm"
              disabled={SubmitLoader || (!isDirty && !hasRequiredFields()) || props.isInactive}
            >
              <Save sx={{ mr: 1 }} />
              Save
            </Fab>
          )}

          <Fab
            color="secondary"
            aria-label="add"
            variant="extended"
            onClick={handleCloseContact}
          >
            <Close sx={{ mr: 1 }} />
            Close
          </Fab>

        </Box>
        <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
          <Alert
            onClose={handleClose}
            severity="success"
            sx={{ width: "100%" }}
          >
            Contact successfully saved!
          </Alert>
        </Snackbar>
        <Snackbar
          open={failureOpen}
          autoHideDuration={2000}
          onClose={handleFailureClose}
        >
          <Alert
            onClose={handleFailureClose}
            severity="error"
            sx={{ width: "100%" }}
          >
            Something went wrong!
          </Alert>
        </Snackbar>
        <Snackbar
          open={duplicateOpen}
          autoHideDuration={2000}
          onClose={handleduplicateOpen}
        >
          <Alert
            onClose={handleduplicateOpen}
            severity="error"
            sx={{ width: "100%" }}
          >
            Contact full name already exists!
          </Alert>
        </Snackbar>

        <SaveCloseDialog
          open={dialogOpen}
          saveAndClose={saveAndClose}
          discardAndClose={discardAndClose}
          setDialogOpen={setDialogOpen}
          isInactive={props.isInactive}
        />
      </TabPanel>
      <TabPanel value={tab} index={1}>
        {!props.isInactive ? (
          <div style={{ height: "calc(100vh - 230px)" }}>
            <PersonStatus currentPerson={{ ...contactDetail }} />
          </div>
        ) : (
          <div style={{ height: "calc(100vh - 230px)" }}>
            This feature is available with an active subscription.
          </div>
        )}
      </TabPanel>
      <TabPanel value={tab} index={2}>
        <Notes
          notes={contactDetail.notes}
          handleChangeNotes={handleChangeNotes}
          onSubmit={onSubmit}
          isInactive={props.isInactive}
        />
      </TabPanel>
      {/*  <TabPanel value={tab} index={2}>
        Forms
      </TabPanel> */}
    </>
  );
};
